import React, { useEffect, useState } from 'react';
import styles from './SoftList.module.less';
import Button from '../../components/Button/Button';
import Btn from '../../components/Btn/Btn';
import classNames from 'classnames';
import InfinteScroll from '../../components/InfinteScroll/GridInfinteScroll';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link, useHistory } from 'react-router-dom';
import { CONTEXT } from '../../config';
import AButton from '../../components/AButton/AButton';
import {
  getSoftCollectList,
  deleteCollectSpecial,
  updateSoftCollectList,
} from '../../actions/collection';
import { useActivate } from 'react-activation';
import defaultImg from '../../static/default.svg';
import nodata from '../../static/collect_blank.svg';
import androidIcon from '../../static/android_logo.svg';
import Loading from '../../components/Loading/Loading';
import { logging } from '../../actions/log';
import Dialog from '../../components/Dialog/Dialog';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectCollectList = createSelector(
  state => state.collection,
  collection => collection,
);
export default ({ loginStatus }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [soft, setSoft] = useState(null);
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const history = useHistory();
  const {
    collectSoftList: { list, pagenation },
    loading,
  } = useSelector(selectCollectList);

  const getData = ({ refresh }) => {
    // eslint-disable-next-line no-nested-ternary
    const skip = refresh ? 0 : list && list.length;
    dispatch(
      getSoftCollectList({
        refresh,
        skip,
        limit: 24,
      }),
    );
  };

  useActivate(() => {
    if (history === 'PUSH') {
      getData({
        refresh: true,
      });
    }
  }, []);
  useEffect(() => {
    if (loginStatus) {
      getData({
        refresh: true,
      });
    } else {
      dispatch(
        updateSoftCollectList({
          error: false,
          list: [],
          code: 200500,
          refresh: true,
          limit: 24,
        }),
      );
    }
  }, [loginStatus]);
  const loadMore = () => {
    getData({
      refresh: false,
    });
  };

  const handleNumber = (data = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+data)) {
      return data;
    }
    if (+data < 1000) {
      return data;
    }
    if (+data < 10000) {
      return `${(data / 1000).toFixed(1)}k`;
    }

    return `${(data / 10000).toFixed(1)}w`;
  };

  const handleDeleteModal = (visible, softs = null, source) => () => {
    // 确认弹窗展示
    if (visible) {
      dispatch(
        logging({
          category: 'P',
          action: 'Mysofts_Collect_Cancel',
          label: '',
          param2: {
            source: 'Mysofts_Collect',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: softs.androidType === '1' ? softs.packageName : softs.softID || softs.softId,
            type: 'soft',
          },
        }),
      );
    } else if (source === 'btn') {
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Collect_Cancel_N',
          label: '',
          param2: {
            source: 'Mysofts_Collect',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: soft.androidType === '1' ? soft.packageName : soft.softID || soft.softId,
            type: 'soft',
          },
        }),
      );
    }
    setSoft(softs);
    setModalVisible(visible);
  };
  const handleDelete = () => {
    dispatch(
      deleteCollectSpecial({
        targetType: soft && soft.androidType === '1' ? 'android' : 'pc',
        targetId: soft && soft.androidType === '1' ? soft.packageName : soft.softID,
        source: 'list',
      }),
    );
    handleDeleteModal(false, null)();
    // 弹窗确认点击
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_Collect_Cancel_Y',
        label: '',
        param2: {
          source: 'Mysofts_Collect',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: soft.androidType === '1' ? soft.packageName : soft.softID,
          type: 'soft',
        },
      }),
    );
  };

  const Soft = ({ softInfo = {} }) => {
    const firstSoft =
      list[0] && (softInfo.androidType === '0' ? list[0].softID : list[0].packageName);
    const isPC = softInfo.androidType === '0';
    return (
      <div
        className={classNames(
          styles.soft,
          firstSoft === (isPC ? softInfo.softID : softInfo.packageName) ? styles.soft_border : '',
        )}
      >
        <div className={styles.soft_content}>
          <Link
            to={
              isPC
                ? `${CONTEXT}/detail/soft/${softInfo.softID}/${softInfo.bizInfo || '{}'}`
                : `${CONTEXT}/adetail/${softInfo.packageName}/${softInfo.versionCode ||
                    0}/${softInfo.bizInfo || '{}'}`
            }
          >
            <div className={styles.soft_icon}>
              <img src={softInfo.logoFile || defaultImg} className={styles.soft_icon}></img>
              {!isPC && <img src={androidIcon} className={styles.android_icon}></img>}
            </div>
          </Link>
          <div className={styles.soft_info}>
            <div>
              {!isPC && (
                <Link
                  to={{
                    pathname: `${CONTEXT}/adetail/${softInfo.packageName}/${softInfo.versionCode ||
                      0}/${softInfo.bizInfo || '{}'}`,
                  }}
                  className={classNames(styles.soft_name, styles.soft_name_active)}
                >
                  {softInfo.softName} <span className={styles.soft_name_desc}>- 手机版</span>
                </Link>
              )}
              {isPC && (
                <Link
                  className={classNames(styles.soft_name, styles.soft_name_active)}
                  to={`${CONTEXT}/detail/soft/${softInfo.softID}/${softInfo.bizInfo || '{}'}`}
                >
                  {softInfo.softName}
                </Link>
              )}
            </div>
            <Link
              to={
                isPC
                  ? `${CONTEXT}/detail/soft/${softInfo.softID}/${softInfo.bizInfo || '{}'}`
                  : `${CONTEXT}/adetail/${softInfo.packageName}/${softInfo.versionCode ||
                      0}/${softInfo.bizInfo || '{}'}`
              }
            >
              <div className={styles.soft_desc} title={softInfo.introduction}>
                {softInfo.introduction}
              </div>
            </Link>
          </div>
          <Link
            to={
              isPC
                ? `${CONTEXT}/detail/soft/${softInfo.softID}/${softInfo.bizInfo || '{}'}`
                : `${CONTEXT}/adetail/${softInfo.packageName}/${softInfo.versionCode ||
                    0}/${softInfo.bizInfo || '{}'}`
            }
          >
            <div className={styles.soft_collect_count}>
              {handleNumber(softInfo.collectCount)}人收藏
            </div>
          </Link>

          <div className={styles.soft_oper}>
            {isPC && (
              <Button
                soft={softInfo || {}}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                  text: '安装',
                }}
                logInfo={{ source: 'Mysofts_Collect' }}
              />
            )}
            {!isPC && (
              <AButton
                soft={softInfo || {}}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                  text: '安装',
                }}
                logInfo={{ source: 'Mysofts_Collect' }}
              />
            )}
            <Btn
              className={classNames(styles.soft_button, styles.soft_button_delete)}
              handleClick={handleDeleteModal(true, softInfo)}
            >
              取消收藏
            </Btn>
          </div>
        </div>
      </div>
    );
  };

  // 加载中
  if (loading && (!list || list.length === 0)) {
    return (
      <div className={styles.blank}>
        <Loading />
      </div>
    );
  }
  //  没有数据
  if (!loading && (!list || list.length === 0)) {
    return (
      <div className={styles.blank}>
        <div className={styles.blank_content}>
          <img alt="" src={nodata} className={styles.blank_img}></img>
          <div className={styles.blank_link}>
            还没有收藏的软件
            <Link
              className={styles.link}
              to={{
                pathname: `${CONTEXT}/`,
              }}
            >
              随便逛逛
            </Link>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className={styles.soft_container}>
        <InfinteScroll
          dataSource={[...list]} // 数据集
          count={pagenation.count}
          height={540} // 高
          width={835} // 宽
          minimumBatchSize={10} // 一行最多统一时间加载个数 默认10
          threshold={10} // 预加载个数
          getItemSize={index => (index !== 0 ? 103 : 103)} // 行高
          loadData={loadMore}
          column={1}
          template={item => {
            return (
              <div>
                <Soft softInfo={item} />
              </div>
            );
          }}
          tpl={() => <div style={{ height: '0px' }}></div>}
        />
      </div>
      {modalVisible && (
        <Dialog
          title="提示"
          maskStyle={styles.mask}
          containerStyle={styles.container}
          handleClose={handleDeleteModal(false)}
        >
          <div className={styles.content}>
            <div className={styles.text}>确认是否要软件从已收藏列表中移除？</div>
            <div className={styles.btn_row}>
              <Btn primary className={styles.btn} handleClick={handleDelete}>
                确定
              </Btn>
              <Btn className={styles.btn} handleClick={handleDeleteModal(false, null, 'btn')}>
                取消
              </Btn>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};
